import graphql__3e3233326cdb5497abb5 from "./__generated__/ContinueOralInterviewMutation.graphql.js";import { commitMutation, graphql } from "react-relay";

import appRelayEnvironment from "../config/AppRelayEnvironment";

const mutation = graphql__3e3233326cdb5497abb5;

const continueOralInterview = (
  variables,
  onCompleted,
  onError = error => console.error(error)
) =>
  commitMutation(appRelayEnvironment, {
    mutation,
    variables,
    onCompleted,
    onError
  });

export { continueOralInterview };
